import * as React from "react";
import { Provider, useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material/styles";

import { MyThemeProvider } from "containers/App/ThemeProvider";
import App from "./containers/App";
import { setupStore } from "./setupStore";
import DragAndDrop from "./containers/Components/DragAndDrop";
import { ScrollToTop } from "./containers/App/ScrollToTop";

export const store = setupStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const Root = () => (
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <MyThemeProvider>
            <DragAndDrop>
              <App />
            </DragAndDrop>
            <ScrollToTop />
          </MyThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
